import ExpandCard from './ExpandCard';
import * as S from './styles';

export interface ExpandCardsProps {
  items: {
    title: string | React.ReactNode;
    description: React.ReactNode;
    id?: number;
  }[];
  defaultOpenId?: number;
  canOpen?:boolean;
}

const ExpandCards = ({ items, defaultOpenId, canOpen = false }: ExpandCardsProps) => {
  return (
    <S.Container>
      {items.map((item, index) => (
        <ExpandCard
          key={index}
          id={item.id}
          title={item.title}
          description={item.description}
          defaultOpen={item.id !== undefined && item.id === defaultOpenId}
          canOpen={canOpen}
        />
      ))}
    </S.Container>
  );
};

export default ExpandCards;
